<ng-container
	*ngIf="data?.resourceData?.settings?.commenting === 'show' || data?.resourceData?.settings?.commenting === 'inactive'">
	<loader [loader]="loader" [type]="'general'"></loader>
	<div class="conversation-container">
		<app-collapsible-block class="collapse-content-area" [data]="{title: title}" color="transparent"
			borderColor="var(--secondary-three)" openColor="#fff" radius="5px" [toggle]="{expanded: true, showToggle: false}"
			(opened)="collapsibleToggle($event)">
			<div class="content-area">
				<div class="post-container" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px"
					fxLayoutGap.xs="15px">

					<ng-container *ngIf="data?.resourceData?.settings?.commenting === 'show'">
						<div fxLayout="row" fxLayoutAlign="center start">
							<div fxFlex="100%" fxFlex.xs="auto" class="post-convers" fxLayout="row" fxLayoutAlign="center start"
								fxLayoutGap="20px" fxLayoutAlign.xs="start center" fxLayoutGap.xs="10px"
								[ngClass]="{'sm' : detectDevice?.resolutionState$?.value?.sm}">
								<!-- <div fxFlex="0 0 70px" fxFlex.xs="0 0 40px">
									<div class="thumbnail-blk">
										<div class="user-thumbnail">
											<img [src]="userThumbnail" (error)="gfService.setErrorImage($event, 'man')"
												alt="">
										</div>
									</div>
								</div> -->
								<div class="form-field" fxFlex="1 1 auto" fxFlex.xs="auto" fxLayout="column"
									fxLayoutAlign="start stretch" fxLayoutGap="10px">
									<div fxLayout="column" fxLayoutAlign="start stretch">
										<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
											fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
											(formObject)="formObjectReader($event)"
											[ngClass]="(submitDisable) ? 'custom-quill-placeholder' : ''">
										</app-form-group>
									</div>

									<!-- <ng-container *ngIf="data?.type==='conversation'">
										<div class="field-hint sub-caption-2">
											{{locale.translate('post_content_helptext')}}
										</div>
									</ng-container> -->
									<!-- <ng-container *ngIf="data?.type==='answer'"> -->
									<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
										<ng-container *ngIf="!submitDisable">
											<div class="btn-blk" fxLayoutAlign="start center">
												<button [disabled]="submitDisable" (click)="submit('addConversation')" mat-button
													class="submit-btn" type="button">{{locale.translate('post')}}
												</button>
											</div>
										</ng-container>
										<div class="hyperlink">
											<!-- {{locale.translate('show_in_editor')}} -->
										</div>
										<div class="hyperlink" (click)="guideline()">
											{{locale.translate('guidelines')}}
										</div>
									</div>
									<!-- </ng-container> -->
								</div>
							</div>
						</div>
					</ng-container>
					<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="5px">
						<app-alert id="conversationAlert"></app-alert>
						<div fxLayout="row" fxLayoutAlign="center start">
							<div fxFlex="90%" fxFlex.xs="auto" class="conversation-block" fxLayout="column" fxFlex="1 1"
								fxFlex.xs="auto" fxLayoutAlign="start stretch" fxLayoutGap="10px" fxLayoutGap.xs="10px">
								<ng-container *ngIf="list.length>0">
									<app-common-list [layout]="'column'" [count]="conversationCount" (loadMoreData)="getList($event)">
										<list-item
											*ngFor="let conversationData of list; let i = index; trackBy: gfService.trackByID.bind({'key': 'recordID'})">
											<content-area>
												<div class="convers-list" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
													<div class="convers-item" [ngClass]="{'publish':conversationData?.status?.key === 'published',
											'moderation':conversationData?.status?.key === 'moderation'}" fxLayout="column"
														fxLayoutAlign="start stretch" fxLayoutGap="5px">
														<div fxLayout="row" fxLayoutAlign="space-between center">
															<div class="user-info" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
																<app-chips type="prime" (title)="searchPeopleDetail(conversationData?.author)"
																	[data]=" conversationData">
																</app-chips>
																<span fxLayoutAlign="center center">{{conversationData.date}}</span>
																<ng-container
																	*ngIf="data?.resourceData?.resourceTypeID?.key === 'answer' &&
																	data?.resourceData?.infoFields?.bestAnswer && data?.resourceData?.infoFields?.bestAnswer?.includes(conversationData?.messageID)">
																	<div fxLayoutAlign="center center">
																		<div class="sub-txt-patch warn">{{
																			locale.translate('asker_choice') }}</div>
																	</div>
																</ng-container>
															</div>

															<ng-container
																*ngIf="conversationData?.status?.key === 'published' && conversationData?.showMenu && data?.resourceData?.settings?.commenting === 'show'">
																<div class="menu-btn">
																	<button mat-icon-button [matMenuTriggerFor]="menu"
																		aria-label="Example icon-button with a menu">
																		<mat-icon>more_vert</mat-icon>
																	</button>
																	<mat-menu #menu="matMenu">
																		<button mat-menu-item
																			(click)="loadResource('editConversation',conversationData,{ index: i})">
																			<span> {{locale.translate('edit')}}</span>
																		</button>
																		<button mat-menu-item
																			(click)="loadResource('deleteConversation',conversationData,{ index: i})">
																			<span>{{locale.translate('delete')}}</span>
																		</button>
																		<!--<button mat-menu-item (click)="loadResource('rejectConversation', conversationData, {
																																								index: i
																																							})">
																		<span> {{locale.translate('unpublish')}}</span>
																	</button> -->
																	</mat-menu>
																</div>
															</ng-container>
														</div>

														<ng-container
															*ngIf="!conversationData.showEditor || conversationData?.status?.key === 'moderation'">
															<div class="converse-content" fxLayout="column" fxLayoutAlign="start stretch"
																fxLayoutGap="10px">
																<app-readability [height]="72" [canRead]="true" type="general">
																	<content>
																		<!-- <div class="convers-desc"
																			[innerHtml]="conversationData.message | contentFormatter | nl2br">
																		</div> -->
																		<ng-container *ngIf="![null,undefined].includes(conversationData.message)">
																			<div class="convers-desc" [innerHtml]="conversationData.message | safeDom">
																			</div>
																		</ng-container>
																	</content>
																</app-readability>
																<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
																	<!-- <mat-icon class="iconcircle">thumb_up_alt</mat-icon>
																<div>{{conversationData.thumbsUpCount}}</div> -->
																	<app-badge [count]="conversationData?.thumbsUpCount"
																		[ngClass]="{'likeColor': (conversationData?.liked === 1)}"
																		(click)="updateLike('like',conversationData)" color="accent" svgIcon="like"
																		size="18px" class="cursor-pointer"></app-badge>
																	<!-- <app-badge [count]="conversationData?.thumbsDownCount"
																		(click)="updateLike('disLike',conversationData)" color="accent" icon="thumb_down"
																		size="18px"></app-badge> -->
																	<ng-container
																		*ngIf="!bestAnswer && data?.resourceData?.resourceTypeID?.key === 'answer' && data?.resourceData?.resourceAction?.askerChoice">
																		<div class="hyperlink" (click)="submit('updateAnswer',conversationData)">
																			{{ locale.translate('mark_as_asker_choice')
																			}}</div>
																	</ng-container>

																</div>
															</div>
														</ng-container>
														<ng-container
															*ngIf="conversationData?.status?.key === 'published' && conversationData.showEditor">
															<div class="convers-form" fxLayout="row wrap" fxLayoutAlign="start stretch"
																fxLayoutGap="15px" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
																fxLayoutGap.xs="10px">
																<div class="form-field" fxFlex="1 1 auto" fxFlex.xs="auto" fxLayout="row"
																	fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayout.xs="start stretch"
																	fxLayoutGap.xs="5px">
																	<app-form-group [fieldList]="conversationData.formFields"
																		[config]="conversationData.config" fxLayout="column" fxLayoutAlign="start stretch"
																		fxLayout.xs="column" fxLayoutAlign.xs="start stretch" fxLayoutGap="10px"
																		fxLayoutGap.xs="10px"
																		(formObject)="conversationObjectReader($event,conversationData)">
																	</app-form-group>
																</div>
																<div class="button-block" fxLayout="column" fxLayoutAlign="center center"
																	fxLayoutGap="8px" fxLayout.xs="row" fxLayoutAling.xs="center center"
																	fxLayoutGap.xs="5px">
																	<button class="sub-action-btn"
																		[disabled]="conversationData.disable || conversationData.buttonDisable"
																		(click)="submit('updateConversation',conversationData)" mat-button
																		type="button">{{locale.translate('update')}}</button>
																	<button class="sub-action-btn" [disabled]="conversationData.disable"
																		(click)="cancel(conversationData)" mat-button
																		type="button">{{locale.translate('cancel')}}
																	</button>
																</div>
															</div>
														</ng-container>
														<ng-container *ngIf="conversationData?.status?.key === 'moderation'">
															<div class="convers-btn-block" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="5px"
																fxLayoutAlign.xs="center center">
																<div>
																	<button class="publish-btn" mat-button>{{locale.translate('publish')}}</button>
																</div>
																<div>
																	<button class="reject-btn"
																		(click)="loadResource('rejectConversation', conversationData, {index: i	})"
																		mat-button>
																		{{locale.translate('reject')}}
																	</button>
																</div>
															</div>
														</ng-container>

													</div>
												</div>
											</content-area>
										</list-item>
									</app-common-list>
								</ng-container>
								<!-- <ng-container *ngIf="list.length === 0 && !loader">
									<div class="no-record" fxLayout="column" fxFlex="1 1 100" fxLayoutAlign="start stretch"
										fxLayoutGap="6px">
										<div class="no-data" fxLayout="row" fxLayoutAlign="center center">
											<p>
												<ng-container *ngIf="data?.type === 'conversation'">
													{{locale.translate('no_conversation_available')}}
												</ng-container>
												<ng-container *ngIf="data?.type === 'answer'">
													{{locale.translate('no_answer_available')}}
												</ng-container>
											</p>
										</div>
									</div>
								</ng-container> -->
							</div>
						</div>
					</div>
					<!-- </div> -->
				</div>
			</div>
		</app-collapsible-block>
	</div>
</ng-container>
